import { render, staticRenderFns } from "./All_Licences.vue?vue&type=template&id=47524486&scoped=true&"
import script from "./All_Licences.vue?vue&type=script&lang=js&"
export * from "./All_Licences.vue?vue&type=script&lang=js&"
import style0 from "./All_Licences.vue?vue&type=style&index=0&id=47524486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47524486",
  null
  
)

export default component.exports